<template>
  <v-container
    class="unauth-bg"
    fluid
  >
    <v-row
      align="center"
      justify="center"
      style="height: 100vh;"
    >
      <v-col
        cols="12"
        class="text-center center-content"
      >
        <div class="unauth-code">
          401
        </div>
        <div class="unauth-title">
          Unauthorized Page
        </div>
        <div class="unauth-subtitle">
          You do not have permission to view this page.
        </div>
        <div class="unauth-subtitle">
          Please contact your administrator.
        </div>
        <v-btn
          class="unauth-btn mt-6"
          @click="goHome"
          outlined
        >
          <v-icon left>
            mdi-arrow-left
          </v-icon>
          Back
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Unauthorized',
  methods: {
    goHome() {
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.unauth-bg {
  background: #faf7f6;
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
}
.center-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10vh;
}
.unauth-code {
  font-size: 8rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 0.5rem;
}
.unauth-title {
  font-size: 2.5rem;
  font-weight: 600;
  color: #222;
  margin-bottom: 0.5rem;
}
.unauth-subtitle {
  font-size: 1.2rem;
  color: #555;
}
.unauth-subtitle + .unauth-subtitle {
  margin-bottom: 1rem;
}
.unauth-btn {
  font-weight: 600;
  letter-spacing: 1px;
  font-size: 1rem;
}
</style>
